const idleStates = ["none"];
const successStates = ["passed", "finished"];
const runningStates = [
  "running",
  "scheduled",
  "canceling",
  "blocked",
  "initiated",
];

const failureStates = ["failed", "canceled", "skipped", "not_run"];

export function isIdle(status) {
  return idleStates.includes(status);
}

export function isSuccessful(status) {
  return successStates.includes(status);
}

export function isRunning(status) {
  return runningStates.includes(status);
}

export function isFailure(status) {
  return failureStates.includes(status);
}

export function isDone(status) {
  return !isRunning(status) && !isIdle(status);
}
